import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../dialogs/Dialog';
import Button from '../../buttons/Button';
import DropDownList from '../../forms/DropDownList';
import Checkbox from '../../forms/Checkbox';
import withMeta from '../../utils/withMeta';
import LoadingPanel from '../../LoadingPanel';
import { buildUrl } from '../../utils/helper';
import "./Prava.scss";

const AKT_DATA = [
  { id: 0, name: 'Doplniť práva' },
  { id: 1, name: 'Zaktualizovať práva' },
  { id: 2, name: 'Obnoviť práva' }
];

const PravaPrj = ({ selected, showMsg, db, primaryField, meta }) => {
  const [state, setState] = useState({
    isOpen: false,
    akt: AKT_DATA[0],
    isLoading: false,
    mL_PRISTUP: false,
    mL_UZ: true,
    mL_SKUP: true
  });

  const handleOpen = () => {
    setState(prevState => ({ ...prevState, isOpen: true }));
  }

  const handleClose = () => {
    setState(prevState => ({ ...prevState, isOpen: false }));
  }

  const handleConfirm = async () => {
    setState(prevState => ({ ...prevState, isLoading: true }));
    try {
      const data = selected.map(x => ({
        iAkt: state.akt.id,
        iPrj: x.IPrj || x.Prj.IPrj,
        iSkup: primaryField === "IPrj" ? null : x.Skup ? x.Skup.ISkup : null,
        iUz: primaryField === "IPrj" ? null : x.Uz ? x.Uz.IUz : null,
        lPristup: state.mL_PRISTUP,
        lUz: primaryField === "IPrj" ? state.mL_UZ : 1,
        lSkup: primaryField === "IPrj" ? state.mL_SKUP : 1
      }));
      await meta.setPravaPrj(data, db);
      showMsg('Akcia priradenia práv prebehla úspešne');
    } catch (error) {
      showMsg(error.message, 'error');
    }

    setState(prevState => ({ ...prevState, isOpen: false, isLoading: false }));
  }

  const handleChange = (name, value) => {
    setState(prevState => ({ ...prevState, [name]: value }));
  }

  const disabled = selected.some(x => x.Zrus === true);

  return (
    <>
      <Dialog
        isOpen={state.isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title='Priradenie práv cez projekt'
        confirmDisabled={primaryField === "IPrj" && !state.mL_UZ && !state.mL_SKUP}
      >
        <div style={{ margin: 10 }}>
          <DropDownList
            name="akt"
            data={AKT_DATA}
            textField="name"
            onChange={handleChange}
            value={state.akt}
          />
          <div className='d-flex flex-column gap-1 mt-3'>
            <Checkbox name={"mL_PRISTUP"} label={"Na čítanie"} value={state.mL_PRISTUP} onChange={(name, value) => handleChange(name, value)} />
            {primaryField === "IPrj" && (
              <>
                <Checkbox name={"mL_UZ"} label={"Priradiť práva pre používateľov"} value={state.mL_UZ} onChange={(name, value) => handleChange(name, value)} />
                <Checkbox name={"mL_SKUP"} label={"Priradiť práva pre skupiny používateľov"} value={state.mL_SKUP} onChange={(name, value) => handleChange(name, value)} />
              </>
            )}
          </div>
          <LoadingPanel isLoading={state.isLoading} />
        </div>
      </Dialog>
      <Button
        onClick={handleOpen}
        title="Priradenie práv cez projekt"
        imageUrl={buildUrl('assets/icons/toolbar/uprava-osoba.svg')}
        disabled={(selected && selected.length === 0) || disabled}
      />
    </>
  );
}

PravaPrj.propTypes = {
  selected: PropTypes.array.isRequired,
  showMsg: PropTypes.func.isRequired,
  db: PropTypes.string,
  primaryField: PropTypes.string,
  meta: PropTypes.object
}

export default withMeta(PravaPrj);